// D-1: loading skeleton — one card-shaped placeholder.
//
// Geometry is locked to the real card so nothing reflows when data lands:
// same container border/radius, same 16:9 thumbnail slot, and a body class
// string byte-identical to StreamCard's (padding 12/13/13, 9px gap — the
// test compares the rendered classNames, so drift fails CI). The title
// block reserves the same 38px the real 2-line-clamped title does; the
// meta bar is 20px, the height of the real meta row's avatar.
//
// Not the old BroadcastSkeleton.js — that matches the legacy card geometry.
//
// All colors come from the browse-* tokens (raw hex fails the designTokens
// jest check).
import React from 'react';

const BAR = 'rounded bg-browse-skeleton';

const SkeletonCard = () => (
  <div
    aria-hidden="true"
    className="bg-browse-surface border border-browse-border rounded-card overflow-hidden"
  >
    <div style={{ aspectRatio: '16 / 9' }} className="relative overflow-hidden bg-browse-skeleton" />
    <div className="flex flex-col gap-2.25 pt-3 px-3.25 pb-3.25">
      <div className="flex min-h-[38px] flex-col gap-1.25">
        <span className={`${BAR} h-3.5 w-full`} />
        <span className={`${BAR} h-3.5 w-3/4`} />
      </div>
      <span className={`${BAR} h-5 w-1/2`} />
    </div>
  </div>
);

export default SkeletonCard;
